import React from 'react';
import { Container } from 'react-bootstrap';
import AppHeader from '../../components/Common/AppHeader';
import AppFooter from '../../components/Common/AppFooter';


const SecurityCompliance = () => (
  <div className="bg-light min-vh-100 d-flex flex-column">
    <AppHeader />
    <Container className="py-5 flex-grow-1 bg-white shadow-sm my-5 rounded p-5">
      <h2 className="fw-bold">Security & Compliance</h2>
      <hr />

      <section className="mb-4">
        <h4>1. Security Philosophy</h4>
        <p>AcademicOS follows a privacy-first, enterprise-grade architecture.</p>
      </section>

      <section className="mb-4">
        <h4>2. Data Security</h4>
        <ul>
          <li>Encryption in transit (TLS)</li>
          <li>Encryption at rest</li>
          <li>Tenant isolation</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4>3. Access Control</h4>
        <p>RBAC, least privilege, and authentication controls are enforced.</p>
      </section>

      <section className="mb-4">
        <h4>4. Monitoring & Logging</h4>
        <p>Audit logs and monitoring systems ensure system integrity.</p>
      </section>

      <section className="mb-4">
        <h4>5. Compliance</h4>
        <p>Aligned with GDPR, India DPDPA, and SOC2 principles.</p>
      </section>

      <section className="mb-4">
        <h4>6. Business Continuity</h4>
        <p>Redundancy, retry mechanisms, and failover systems are in place.</p>
      </section>

    </Container>
    <AppFooter />
  </div>
);
export default SecurityCompliance;
